module.exports = __webpack_public_path__ + "static/media/slider.71898e6a.png";